export default __webpack_public_path__ + "static/media/store.d71c67d1.png";